
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from '../../components/feature/Hero';
import AboutSection from '../../components/feature/AboutSection';
import ServicesSection from '../../components/feature/ServicesSections';
import WhyAlphadenSection from '../../components/feature/WhyAlphadenSoln';
import UpdatesSection from '../../components/feature/UpdatesSection';
import VideoShowcase from '../../components/feature/VideoShowcase';

export default function Home() {
  

  return (
    <div className="min-h-screen bg-white">
      <div className='relative'>
      <Header />
      <Hero/>
      </div>
    <AboutSection/>
    <ServicesSection/>
    <VideoShowcase/>
    <WhyAlphadenSection/>
    <UpdatesSection/>
      <Footer />
    </div>
  );
}